import { ProposalQuoteConditions } from '@/types/management.types'
import React from 'react'

interface LeaseConditionsProps {
  conditions?: ProposalQuoteConditions
}

const LeaseConditions: React.FC<LeaseConditionsProps> = ({
  conditions = {
    leaseAmount: '375000',
    insurance: '8500',
    totalInitialAmount: '83500',
    openingFee: '3000',
    residualValueNoTax: '168750',
    monthlyRentNoTax: '12450',
    monthlyDiscount: '500',
    totalRentWithDiscount: '11950',
    rentTax: '1912',
    reserveFund: '750',
    totalRentWithTax: '14612',
  },
}) => {
  const rightArrowIcon = '/assets/right-arrow.png'

  const {
    leaseAmount,
    insurance,
    totalInitialAmount,
    openingFee,
    residualValueNoTax,
    monthlyRentNoTax,
    monthlyDiscount,
    totalRentWithDiscount,
    rentTax,
    reserveFund,
    totalRentWithTax,
  } = conditions || {}

  const formatToPesos = (value: string): string => {
    const numericValue = parseFloat(value)
    if (isNaN(numericValue)) return value

    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numericValue)
  }

  const conditionItems = [
    { label: 'Monto del arrendamiento', value: leaseAmount },
    { label: 'Seguro anual', value: insurance },
    {
      label: 'Total pago inicial',
      value: totalInitialAmount,
    },
    {
      label: 'Comisión por apertura',
      value: openingFee,
    },
    {
      label: 'Valor residual sin IVA',
      value: residualValueNoTax,
    },
    {
      label: 'Renta mensual sin IVA',
      value: monthlyRentNoTax,
    },
    { label: 'Descuento mensual', value: monthlyDiscount },
    {
      label: 'Total de renta con descuento',
      value: totalRentWithDiscount,
    },
    { label: 'IVA de renta', value: rentTax },
    { label: 'Fondo de reserva', value: reserveFund },
    {
      label: 'Total renta mensual con IVA',
      value: totalRentWithTax,
    },
  ]

  return (
    <div className="max-w-2xl my-5">
      <h2 className="text-md font-bold mb-4 text-gray-800">
        Condiciones de arrendamiento:
      </h2>

      <div className="border border-[#225EAC] rounded-lg p-5 bg-red ">
        {conditionItems.map((item, index) => (
          <div key={index} className={`flex justify-between items-center py-2`}>
            <div className="flex items-center text-gray-900 font-bold">
              <img src={rightArrowIcon} alt="arrow" className="w-4 h-4 mr-3" />
              {item.label}
            </div>
            <div className="font-medium text-gray-800 text-left w-1/3">
              {formatToPesos(item.value as string)}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default LeaseConditions
